import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import dayjs from "dayjs";
import $ from 'jquery';
import 'magnific-popup';

const StudentTimeTable = () => {
    const [timetables, setTimetables] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    // Refs to track up-to-date state inside scroll handler
    const offsetRef = useRef(0);
    const loadingRef = useRef(false);
    const hasMoreRef = useRef(true);

    const fetchTimetables = useCallback(async () => {
        if (loadingRef.current || !hasMoreRef.current) return;

        loadingRef.current = true;
        setLoading(true);

        try {
            const res = await axios.get("/api/student/get-student-timetable", {
                params: { offset: offsetRef.current }
            });

            const newTimetables = res.data.data || [];

            setTimetables((prev) => [...prev, ...newTimetables]);

            if (newTimetables.length < 10) {
                setHasMore(false);
                hasMoreRef.current = false;
            } else {
                offsetRef.current += 10;
            }
        } catch (err) {
            console.error("Error fetching timetables", err);
        }

        setLoading(false);
        loadingRef.current = false;
    }, []);

    useEffect(() => {
        fetchTimetables(); // Load first 10 timetables
    }, [fetchTimetables]);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + document.documentElement.scrollTop + 50 >=
                document.documentElement.scrollHeight
            ) {
                fetchTimetables();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [fetchTimetables]);

    return (
        <div className="row gy-44">
            <div className="col-xxl-6">
                <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
                    <div className="card-header py-16 px-10 bg-base border border-end-0 border-start-0 border-top-0">
                        <h3 className="mb-0">TimeTable</h3>
                    </div>
                    <div className="card-body p-10 pt-10">
                        {timetables.map((item, index) => (
                            <div key={index} className="notification-card mb-3">
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Send Date </label>: {dayjs(`${item.added_datetime}`).format('DD/MM/YYYY')}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Sended By </label>: {item.User?.first_name} {item.User?.last_name}
                                    </div>
                                </div>
                                <div className="row gy-3">
                                    <div className="col-12">
                                        <label className="form-label">Valid </label>: {dayjs(`${item.valid_from}`).format('DD/MM/YYYY')} To {dayjs(`${item.valid_to}`).format('DD/MM/YYYY')}
                                    </div>
                                </div>
                                {item.filename && (
                                    <div className="row gy-3">
                                        <div className="col-12 text-center">
                                        {(() => {
                                            const fileUrl = `${process.env.REACT_APP_BASE_SITE_URL}/uploads/TimeTable/${item.filename}`;
                                            const ext = item.filename.split(".").pop().toLowerCase();
                                            const anchorId = `popup-link-${index}`; // unique ID for each anchor

                                            if (ext === "pdf") {
                                            return (
                                                <button
                                                className="btn btn-primary"
                                                style={{ fontWeight: 700 }}
                                                onClick={() => window.open(fileUrl, "_blank")}
                                                >
                                                View PDF
                                                </button>
                                            );
                                            } else {
                                            return (
                                                <>
                                                {/* Hidden anchor tag that triggers popup */}
                                                <a
                                                    id={anchorId}
                                                    href={fileUrl}
                                                    className="popup-link"
                                                    style={{ display: "none" }}
                                                >
                                                    Open Image
                                                </a>

                                                {/* Visible button that triggers anchor programmatically */}
                                                <button
                                                    className="btn btn-primary"
                                                    style={{ fontWeight: 700 }}
                                                    onClick={() => $(`#${anchorId}`).magnificPopup({ type: 'image', closeOnContentClick: true,image: { verticalFit: true } }).magnificPopup('open')}
                                                >
                                                    View Document
                                                </button>
                                                </>
                                            );
                                            }
                                        })()}
                                        </div>
                                    </div>
                                )}

                            </div>
                        ))}
                        {loading && <p>Loading...</p>}
                        {!hasMore && <p className="error">No more timetables</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentTimeTable;